module.exports = __webpack_public_path__ + "media/typy/ciezarowe-a5eb778f.png";